import posthog from 'posthog-js';
import type { UserProfile } from '@/api/user';
import { getDisplayName } from '@/api/user';
import { getPlatform } from '@/api/config';
import { IS_POSTHOG_CONFIGURED } from '@/analytics/posthog.client';

export const identifyUser = (user: UserProfile | null): void => {
  if (!IS_POSTHOG_CONFIGURED || !user) {
    return;
  }

  const platform = getPlatform();
  posthog.identify(
    user.id,
    {
      $name: getDisplayName(user).trim() || 'Unknown',
      $email: user.email ?? undefined,
      account_id: user.accountId ?? undefined,
      language_slug: user.languageSlug ?? undefined,
      role: user.role ?? undefined,
      platform,
    },
    { first_platform: platform },
  );
};

export const resetPosthogIdentity = (): void => {
  if (!IS_POSTHOG_CONFIGURED) {
    return;
  }
  posthog.reset();
  // reset() clears super properties, so the platform has to be registered again.
  posthog.register({ platform: getPlatform() });
};
